module.exports = __webpack_public_path__ + "static/img/gaozhongwuli.5af9d37c.jpg";